import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { buildQueryString, doGetPromise } from '../../../../config/core.httpclient-utils';

import { StateService } from '@uirouter/angular';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { FilterService } from '../../../../services/core.filter.service';
import { UiService } from '../../../../services/core.ui.service';
import { SystemLogReportHelper } from './reports.system-log.service';

import * as _ from 'lodash-es';

@Component({
    selector: 'siteLogView',
    template: require('./reports.system-log.component.html')
})
export class AdminSystemLogReportComponent implements OnInit {
    protected active = '';

    protected data: any = [];
    private url = '/api/log';
    protected sortFields;
    private sort;
    private paging;
    private baseFilters;
    protected filters;

    constructor(
        private stateService: StateService, 
        private filterService: FilterService,
        private uiService: UiService,
        private systemLogReportHelper: SystemLogReportHelper,
        private http: HttpClient,
        private gfTranslateService: GfTranslateService
    ) { }
    
    ngOnInit() {
        this.sortFields = this.systemLogReportHelper.getSortFields();
        this.sort = this.filterService.getSortValues();
        this.paging = this.filterService.getPagingValues();
        this.baseFilters = this.systemLogReportHelper.getBaseFilters();
        this.filters = this.initFilters();
        this.refreshData();
    };

    onApplyFilters () {
        this.paging.page_num = 1;
        this.applyFilters();
    };

    onResetFilters () {
        this.paging.page_num = 1;
        this.filters = {
            main_fields: _.cloneDeep(this.baseFilters)
        };
        this.applyFilters();
    };

    onSort (params) {
        this.sort = {
            sort_field: _.get(params, 'key', 'logDate'),
            sort_dir: _.get(params, 'sortDir', 'desc')
        };
        this.applyFilters();
    };

    getDownloadUrl (format) {
        var fetchArgs = this.filterService.getFetchArgs({});
        fetchArgs.download = true;
        fetchArgs.format = format;
        delete fetchArgs.$inherit;  // Why is this in here?

        return this.url + "?" + buildQueryString(fetchArgs)
    };

    onPaging (params) {
        _.assignIn(this.paging, params);
        this.applyFilters();
    };

    refreshData = () => {
        this.data = false;

        var fetchArgs = this.filterService.getFetchArgs({});

        doGetPromise(
            this.http,
            this.url,
            fetchArgs
        ).then(
            (response) => {
                this.data = _.get(response, 'items', []);
            },
            (response) => {
                console.log(response);
                this.data = [];
                var msg = this.gfTranslateService.translate('There was a problem loading System Log data');
                this.uiService.message.showWarning(msg, 'Data Error');
            }
        );
    };

    initFilters() {
        return {
            main_fields: this.systemLogReportHelper.setFiltersFromStateParams(
                _.cloneDeep(this.baseFilters)
            )
        };
    }

    applyFilters(overrides = {}) {
        var newParams = _.pickBy(Object.assign(
            {},
            this.sort,
            this.paging,
            this.filterService.getFilterValues(
                _.get(this.filters, 'main_fields', [])
            ),
            overrides
        ), function (value) {
            return (undefined != value && null != value && value != '');
        });

        // This call needs inherit: false to allow
        // empty params to replace non-empty values in route/URL
        // (e.g., s=maillog => s='')
        this.stateService.go('.', newParams, { location: 'replace', inherit: false })
            .then(this.refreshData);
    }
}